export enum AsyncStatus {
  Initial = "initial",
  Requested = "requested",
  Success = "success",
  Error = "error",
}
